import { getFeatureSwitchValueStatic } from '../utils/general';
export var RETURN_INITIATED_REFUND_TIMING_MESSAGE = 'Once we’ve received and processed your return, it may take up to 10 business days for your bank to put the funds back into your account.';
export var RETURN_COMPLETED_REFUND_TIMING_MESSAGE = 'Your return is complete! It may take up to 10 business days for your bank to put the funds back into your account.';
export var RETURN_API_ERROR = " We're sorry. There was a temporary technical error. Please try again shortly.";
export var PRINT_LABEL_MINIMUM_VERSION = {
    iOS: getFeatureSwitchValueStatic('iOSPrintLabelVersion') || '7.34.0',
    Android: getFeatureSwitchValueStatic('AndroidPrintLabelVersion') || '7.34.0',
};
export var RETURN_STATUS;
(function (RETURN_STATUS) {
    RETURN_STATUS["INITIATED"] = "Return Initiated";
    RETURN_STATUS["IN_PROGRESS"] = "Return In Progress";
    RETURN_STATUS["COMPLETED"] = "Return Completed";
})(RETURN_STATUS || (RETURN_STATUS = {}));
